import React from 'react';

const Loading = () => {
  return (
    <div className="teamsport_content">
      <div className="main_container">
        <div className="loadingContainer">
          <div className="loadingHolder">
            <div className="loader" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Loading;
